<template>
    <div>
      <!-- <h3>Signups</h3> -->
      <div v-if="labels">
        <AreaChart
          :chartData="chartdata"
          :chartoptions="chartoptions"
          :key="`${datesrange[0]}+${datesrange[1]}+${datesrangetype}+'10'`"
        />
      </div>
    </div>
  </template>
  
  <script>
  import { getOrgStats } from "../../plugins/getAnalysics";
  import { mapGetters } from "vuex";
  
  export default {
    name: "UsageTimeChart",
  
    components: {
      AreaChart: () => import("@/components/charts/AreaChart"),
    },
  
    data() {
      return {
        signups: null,
        transcripts: null,
        time: null,
        labels: null,
        chartoptions: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: "SIGNUPS & TIME",
                },
                id: "left",
                stacked: false,
                // ticks: {
                //   beginAtZero: true
                // }
              },
              {
                scaleLabel: {
                  display: true,
                  labelString: "TRANSCRIPTS",
                },
                id: "right",
                position: "right",
                stacked: false,
                // ticks: {
                //   beginAtZero: true
                // }
                gridLines: {
                  color: "rgba(0, 0, 0, 0)",
                },
              },
            ],
          },
        },
      };
    },
  
    props: {
      orgId: {
        default: () => ({}),
      },
      userId: {
        default: () => ({}),
      },
    },
  
    computed: {
      ...mapGetters({
        datesrange: "datesrange",
        datesrangetype: "datesrangetype",
      }),
      chartdata() {
        let a = {
          labels: this.chartLabels,
          datasets: [
            {
              label: "SIGNUPS",
              borderColor: "#25da3c",
              pointBackgroundColor: "white",
              borderWidth: 4,
              pointBorderColor: "#25da3c",
              backgroundColor: "white",
              data: this.signups,
              yAxisID: "left",
            },
            {
              label: "TRANSCRIPTS",
              borderColor: "#D8D8D8",
              pointBackgroundColor: "white",
              borderWidth: 4,
              pointBorderColor: "#D8D8D8",
              backgroundColor: "white",
              data: this.transcripts,
              yAxisID: "right",
            },
            {
              label: "TIME",
              borderColor: "#FFEA25",
              pointBackgroundColor: "white",
              borderWidth: 4,
              pointBorderColor: "#FFEA25",
              backgroundColor: "white",
              data: this.time,
              yAxisID: "left",
            },
          ],
        };
        return a;
      },
      chartLabels() {
        return this.labels;
      },
    },
  
    watch: {
      // eslint-disable-next-line no-unused-vars
      datesrangetype(newValue, oldValue) {
        this.getChartData();
      },
    },
  
    methods: {
      async getChartData() {
        const chartDataByYearMonth = await getOrgStats({
          queryType: "chartUsageDataByTimeframe",
          orgId: this.orgId,
          userId: this.userId,
          datesrange: this.datesrange,
          datesrangetype: this.datesrangetype,
        });
        let data = chartDataByYearMonth.data;
        this.chartDataByYearMonth = chartDataByYearMonth.data;
  
        console.log(chartDataByYearMonth);
  
        let labels = [];
        let signups = [];
        let transcripts = [];
        let time = [];
        data.forEach(async (item) => {
          labels.push(item.month.value);
          signups.push((item.signup_count || "0").toString());
          transcripts.push((item.transc_count || "0").toString());
          let hourstime = ((item.transc_time || "0") / 3600).toFixed(1);
          time.push(hourstime.toString());
        });
        this.labels = labels;
        this.signups = signups;
        this.transcripts = transcripts;
        this.time = time;
      },
    },
  
    async mounted() {
      await this.getChartData();
    },
  };
  </script>
  